import React, { useMemo, memo, useCallback, useEffect, useState } from "react";
import { useCtx, useT, withRedux, WithReduxHocPropsType } from "@al/next/al-ex";

import HalfPopup from "~/components/ui/HalfPopup";

import redux from "../../../redux/helper";
import { PresellSupportType, SaleStockInfoType, SkuInfoType, SellStatusType } from "../../../types";

import { GuaranteeType } from "./types";
import styles from "./styles.scss";

interface Props extends WithReduxHocPropsType {
  presellSupport: PresellSupportType;
  saleStockInfos: SaleStockInfoType[];
  currentSku: SkuInfoType;
}

const PlatformGuarantee: React.FC<Props> = (props) => {
  const ctx = useCtx();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<GuaranteeType>();
  const [visible, setVisible] = useState(false);
  const t = useT();
  const { currentSku, saleStockInfos, presellSupport } = props;

  const closePopup = useCallback((): void => {
    setVisible(false);
  }, []);

  const showPopup = useCallback((): void => {
    setVisible(true);
  }, []);

  useEffect(() => {
    async function getVatInfos(): Promise<void> {
      const { data, success } = await ctx.store.dispatch(redux.actions.asyncGetPlatformGuarantee({}));
      success && setItems(data);
      setLoading(false);
    }
    getVatInfos();
  }, []);

  if (!loading && items?.vendorPlatformInfos === null) {
    return null;
  }

  const currentSkuSellStatus = useMemo(
    () => saleStockInfos?.find((item) => item.skuId === currentSku?.skuId)?.sellStatus,
    [currentSku, saleStockInfos]
  );

  // 预售商品
  const currentVendorPlatformInfos = useMemo(() => {
    if (
      currentSkuSellStatus === SellStatusType.PreSale &&
      presellSupport === PresellSupportType.Yes &&
      items?.vendorPlatformInfos?.length
    ) {
      return items?.vendorPlatformInfos.filter((item) => item.infoName !== "Produk dikirimkan maks 48 jam");
    }
    return items?.vendorPlatformInfos;
  }, [currentSkuSellStatus, presellSupport, items?.vendorPlatformInfos]);

  if (!currentVendorPlatformInfos?.length) {
    return null;
  }

  return (
    <>
      <ul className={styles.icons} onClick={showPopup}>
        {currentVendorPlatformInfos?.map((item, i) => (
          <li className={styles.icons_item} key={item.infoLogo + i}>
            <img className={styles.icon} src={item.infoLogo} alt={item.infoName} />
            <div className={styles.name}>{item.infoName}</div>
          </li>
        ))}
      </ul>
      <HalfPopup
        visible={visible}
        title={t("平台保障")}
        onMaskClick={closePopup}
        onClose={closePopup}
        headerTextAlign="left"
        destroyOnClose
        bodyClassName={styles.guarantee_pop}
      >
        <div className={styles.wrap}>
          {currentVendorPlatformInfos?.map((item, i) => (
            <div className={styles.item_box} key={item.infoLogo + i}>
              <img className={styles.icon} src={item.infoLogo} alt={item.infoName} />
              <div className={styles.info}>
                <div className={styles.name}>{item.infoName}</div>
                <div className={styles.desc}>{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      </HalfPopup>
    </>
  );
};

export default withRedux((state) => ({
  currentSku: state.static.currentSku,
  saleStockInfos: state.static.saleStockInfos,
}))(memo(PlatformGuarantee));
